// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"3b53517f","349":"3b53517f","466":"3b53517f","670":"3b53517f","842":"3b53517f"}[chunkId] + ".chunk.css";
};